'use client'

import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { Check } from 'lucide-react'
import * as React from 'react'

import { Label } from '../label/Label'
import { cn } from '../lib/cn'

const CheckboxBlock = React.forwardRef<
  React.ComponentRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'peer h-4 w-4 shrink-0 rounded-sm border border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 cursor-pointer disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground',
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator className={cn('flex items-center justify-center text-current')}>
      <Check className='h-4 w-4' />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
CheckboxBlock.displayName = CheckboxPrimitive.Root.displayName

export type CheckboxProps = React.ComponentPropsWithoutRef<typeof CheckboxBlock> & {
  wrapperClassName?: string
}

const Checkbox = ({ children, wrapperClassName, ...props }: CheckboxProps) => (
  <div className={cn('flex items-center gap-2 cursor-pointer', wrapperClassName)}>
    <CheckboxBlock {...props} />
    <Label htmlFor={props.id}>{children}</Label>
  </div>
)

export { Checkbox, CheckboxBlock }
